import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  height: ", "px;\n  line-height: ", "px;\n  margin-right: 16px;\n  cursor: pointer;\n\n  a {\n    &:active,\n    &:hover,\n    &:link,\n    &:visited {\n      color: inherit;\n      text-decoration: none;\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  &&& {\n    display: inline-block;\n\n    &:before {\n      width: 24px;\n      font-size: 24px;\n      vertical-align: top;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { Icon } from '@alicloud/console-components';
import { headerHeight } from './Header';
export var BackArrowIcon = styled(Icon)(_templateObject());
var BackArrow = styled.span(_templateObject2(), headerHeight, headerHeight);
export default BackArrow;